import { Col, Container, Row } from "react-bootstrap";
import { GoTriangleRight } from "react-icons/go";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import CardItemTravelBasic from "../../../../components/molecules/CardItemTravelBasic";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PaginationList from "../../../../../../components/organisms/pagination-list/PaginationList";
import { getAllTrips } from "../../../../../../api/modules/admin";


const RowStyled = styled(Row)`
  position: relative;
  width: 100%;
  bottom: 0px;
  margin-top: 20px;
`;

const DivEmpty = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
`;

const ContainerList = styled.div`
  height: auto;
  overflow-y: overlay;
  padding-right: 10px;
`;
const Search = styled.div`
  /* background-color: white; */
  border: none;
  width: 10%;
  padding: 2px 2px;
  border-radius: 6px;
  /* box-shadow: 0px 0px 5px #cccccc; */
  margin-left: 3px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #92c31a;
  :hover {
    cursor: pointer;
  }
`;

const FinishedTravelsTC = ({ id, searchQuery, ...rest }) => {
  const history = useHistory();
  const spinner = useSelector((state) => state.appReducer.isLoading);
  const [page, setPage] = useState(0);
  const numberList = 5;
  const INITIAL_STATE = {
    total: 0,
    items: [],
  };
  const [tripsAPI, setTripsAPI] = useState(INITIAL_STATE);
  const [query, setQuery] = useState({
    limit: numberList,
    from: page,
    state: 5,
    user_id: id,
    status: true,
  });

  const fetchData = async () => {
    const tripsResponse = await getAllTrips({ ...query, ...searchQuery });

    const { trips, total } = tripsResponse;
    if (trips)
      setTripsAPI({
        ...INITIAL_STATE,
        items: trips,
        total,
      });
  };

  useEffect(() => {
    setQuery((prev) => {
      return {
        ...prev,
        limit: numberList,
        from: 0,
      };
    });
    setPage(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchQuery]);

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const handlePreviewPage = () => {
    setQuery((prev) => {
      return {
        ...prev,
        limit: numberList,
        from: numberList * page - numberList,
      };
    });
    setPage((prev) => prev - 1);
  };
  const handleNextPage = () => {
    setPage((prev) => prev + 1);
    setQuery((prev) => {
      return {
        ...prev,
        limit: numberList,
        from: numberList * (page + 1),
      };
    });
  };
  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <ContainerList>
              
              {tripsAPI?.items.length ? (
                tripsAPI?.items.map((location, index) => (
                  <CardItemTravelBasic
                    state="Finalizado"
                    btnIcon={<GoTriangleRight />}
                    key={index}
                    originName={location.origin_site.address}
                    destinyName={location.destiny_site.address}
                    withdrawDate={location.withdraw_date}
                    deliveryDate={location.delivery_date}
                    onClick={() => {
                      history.push(
                        `?tripId=${location._id || "0"}`
                      );
                    }}
                    trucks_number_accepted={location.counterTripdetails}
                    trucksNumber={location.totalTripsDetails}
                    showId={location.id_trip}
                  ></CardItemTravelBasic>
                ))
              ) : (
                <DivEmpty>
                  {!spinner ? (
                    <h2 className="font-weight-bold h3 text-center">
                      No hay viajes disponibles
                    </h2>
                  ) : null}
                </DivEmpty>
              )}
            </ContainerList>
          </Col>
        </Row>
      </Container>
      <RowStyled>
        <Col md="12">
          <PaginationList
            items={tripsAPI.items}
            total={tripsAPI.total}
            currPage={page}
            handlePreviewPage={handlePreviewPage}
            handleNextPage={handleNextPage}
            numberList={numberList}
          />
        </Col>
      </RowStyled>
    </>
  );
};

export default FinishedTravelsTC;
